<template>
    <div>
        <div class="header" style="display: flex; align-items: center; justify-content: space-between; height: 60px; border-bottom: solid 1px lightgray; background-color: #4570c7; color: white;">
            <router-link to="/projects">
                <div style="display: flex; align-items: center; margin-left: 16px; color: white; width: 44px; height: 100%; text-align: center;">
                    <i class="fas fa-arrow-left"></i>
                </div>
            </router-link>
            <div style="font-size: 17px; margin: 8px 16px; width: 100%; text-align: center;">
                Invite
            </div>
            <div style="margin: 8px 0; display: flex; align-items: center;">
                <el-dropdown trigger="click">
                    <span class="el-dropdown-link">
                        <div style="display: flex; align-items: center; color: white; width: 44px; height: 100%; text-align: center; align-items: center;">
                            <i class="fas fa-ellipsis-v" style="margin: 0 auto; width: 32px; cursor: pointer;"></i>
                        </div>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                        <el-dropdown-item @click.native="reloadWindow()">Refresh</el-dropdown-item>
                        <el-dropdown-item @click.native="$router.push('/projects')">Projects</el-dropdown-item>
                        <el-dropdown-item divided @click.native="handleLogout">Logout</el-dropdown-item>
                    </el-dropdown-menu>
                </el-dropdown>
            </div>
        </div>
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center; height: 100%; margin-top: 16px;">
            <el-card class="box-card" style="max-width: 600px; margin: 0 auto; width: 90%; background: #f6f8ff;">
                <div style="font-weight: 700; margin-bottom: 32px;">
                    Invite your colleagues
                </div>
                <div style="margin-top: 16px;">
                    <el-input type="email" placeholder="Email" v-model="userInfo.email" required></el-input>
                </div>
                <div style="margin-top: 16px;">
                    <el-input type="text" placeholder="Company name" v-model="userInfo.company_name" required></el-input>
                </div>
                <div style="margin-top: 16px;">
                    <el-input type="text" placeholder="First name" v-model="userInfo.first_name" required></el-input>
                </div>
                <div style="margin-top: 16px;">
                    <el-input type="text" placeholder="Last name" v-model="userInfo.last_name" required></el-input>
                </div>
                <div style="margin-top: 32px; margin-bottom: 32px;">
                    <div style="display: flex; align-items: center; flex-direction: row-reverse;">
                        <el-button v-loading="loading" type="primary" @click.native="handleInvite" style="width: 100%;">Generate Link</el-button>
                    </div>
                    <div v-if="errorMessage" style="color: red; margin-top: 10px;">
                        {{errorMessage}}
                    </div>
                </div>
            </el-card>
            <el-dialog title="Invite Link" :visible.sync="showInviteLinkDialog" width="90%" center style="max-width: 600px;">
                <el-input readonly v-model="inviteLink"></el-input>
                <span slot="footer" class="dialog-footer">
                    <div style="display: flex; flex-direction: column;">
                        <div v-if="0">
                            <a :href="`sms:&body=Upload%20photos%20of%20our%20projects%20using%20this%20link%20${encodeURIComponent(this.inviteLink)}`">
                                <el-button type="primary" style="width: 200px; margin-bottom: 10px;">Invite by SMS</el-button>
                            </a>
                        </div>
                        <div>
                            <a :href="`whatsapp://send?text=Upload%20photos%20of%20our%20projects%20using%20this%20link%20${encodeURIComponent(this.inviteLink)}`">
                                <el-button type="primary" style="width: 200px; margin-bottom: 10px;">Invite by WhatsApp</el-button>
                            </a>
                        </div>
                        <div>
                            <a :href="`mailto:?subject=Upload%20photos%20of%20our%20projects&body=Upload%20photos%20of%20our%20projects%20using%20this%20link:%20${encodeURIComponent(this.inviteLink)}`">
                                <el-button type="primary" style="width: 200px; margin-bottom: 10px;">Invite by Email</el-button>
                            </a>
                        </div>
                        <div>
                            <el-button type="primary" @click="copy" style="width: 200px;">Copy</el-button>
                        </div>
                    </div>
                </span>
            </el-dialog>
        </div>
    </div>
</template>
<script>
import axios from 'axios'
import auth from '@/auth'
export default {
    data() {
        return {
            showInviteLinkDialog: false,
            inviteLink: null,
            loading: false,
            errorMessage: null,
            userInfo: {}
        }
    },
    methods: {
        copyToClipboard(str) {
            const el = document.createElement('textarea'); // Create a <textarea> element
            el.value = str; // Set its value to the string that you want copied
            el.setAttribute('readonly', ''); // Make it readonly to be tamper-proof
            el.style.position = 'absolute';
            el.style.left = '-9999px'; // Move outside the screen to make it invisible
            document.body.appendChild(el); // Append the <textarea> element to the HTML document
            const selected =
                document.getSelection().rangeCount > 0 // Check if there is any content selected previously
                ?
                document.getSelection().getRangeAt(0) // Store selection if found
                :
                false; // Mark as false to know no selection existed before
            el.select(); // Select the <textarea> content
            document.execCommand('copy'); // Copy - only works as a result of a user action (e.g. click events)
            document.body.removeChild(el); // Remove the <textarea> element
            if (selected) { // If a selection existed before copying
                document.getSelection().removeAllRanges(); // Unselect everything on the HTML document
                document.getSelection().addRange(selected); // Restore the original selection
            }
        },
        copyAndClose() {
            this.copyToClipboard(this.inviteLink);
            this.showInviteLinkDialog = false;
            this.$message({
                type: 'success',
                message: 'Copied!'
            });
        },
        handleLogout() {
            auth.logout();
        },
        copy() {
            this.copyToClipboard(this.inviteLink);
            this.$message({
                type: 'success',
                message: 'Copied!'
            });
        },
        generateInviteCode(length) {
            var result = '';
            var characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
            var charactersLength = characters.length;
            for (var i = 0; i < length; i++) {
                result += characters.charAt(Math.floor(Math.random() * charactersLength));
            }
            return result;
        },
        handleInvite() {
            this.errorMessage = null;
            this.loading = true;
            this.userInfo.invite_code = this.generateInviteCode(7);
            axios.post('/users', {
                    data: {
                        type: 'users',
                        attributes: this.userInfo
                    }
                })
                .then(response => {
                    this.inviteLink = `https://manager.projectsmaps.com/#/i/${response.data.data.attributes.invite_code}`;
                    this.showInviteLinkDialog = true;
                })
                .catch(error => {
                    console.log(error);
                    this.errorMessage = 'An error occured'
                })
                .finally(() => {
                    this.loading = false;
                });
        }
    }
}
</script>